import React from 'react';
import { Box } from '@mui/material';
import { useNotifications } from '../../contexts/NotificationContext';
import NotificationItem from './NotificationItem';

/**
 * Composant NotificationCenter - Style iOS/macOS
 * Affichage des notifications empilées en haut à droite
 * Design sobre et élégant avec transparence
 */
const NotificationCenter = ({ isVisible = true }) => {
  const { notifications, initialLoadComplete, initialLoadTimestamp } = useNotifications();

  // Filtrer les notifications:
  // 1. Non supprimées
  // 2. Créées APRÈS le chargement initial de la page
  const visibleNotifications = notifications.filter(notification => {
    if (notification.deleted) return false;

    if (!initialLoadComplete || !initialLoadTimestamp) return false;

    const notifCreatedAt = notification.createdAt?.getTime ? notification.createdAt.getTime() : 0;
    return notifCreatedAt > initialLoadTimestamp;
  });

  // Ne rien afficher si pas de notifications ou si masqué
  if (!isVisible || !visibleNotifications || visibleNotifications.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '90px', // Juste sous la barre d'outils
        right: '20px',
        zIndex: 9999,
        pointerEvents: 'none', // Permet de cliquer à travers le conteneur
        width: '360px',
        maxWidth: 'calc(100vw - 40px)',
        
        // Responsive mobile
        '@media (max-width: 768px)': {
          right: '10px',
          width: 'calc(100vw - 20px)',
          maxWidth: '360px'
        }
      }}
    >
      {/* Afficher seulement les 5 dernières notifications */}
      {visibleNotifications.slice(0, 5).map((notification, index) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          index={index}
          isStacked={true}
        />
      ))}
    </Box>
  );
};

export default NotificationCenter; 